import '../App.css';
import img_tablet from '../tablet.png';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import UserHeader from '../UserHeader';

function Device({ device, loadDevices }) {
    const navigate = useNavigate();

    function deleteDevice(id) {
        axios.delete(
            process.env.REACT_APP_API_HOST + `/devices/${id}/`
        ).then(
            (response) => {
                loadDevices();
            }
        );
    }

    return (
        <div
            className='standard-box2'
            align='left'
            style={{ width: '30em' }}
        >
            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    cursor: 'pointer',
                }}
                onClick={
                    () => navigate(`/devices/how_to_connect/?device_id=${device.id}`)
                }
            >
                <img src={img_tablet} width={180} />
                <div style={{ marginLeft: '1em', width: '10em' }}>
                    <h2
                        style={{
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {device.title}
                    </h2>
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                        }}
                    >
                        <UserHeader user_id={device.owner_id} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Device;